import { useContext } from "react";

import { ChatAssistantAttachmentContext } from "./ChatAssistantAttachmentContext";

export function useChatAssistantAttachments() {
  const context = useContext(ChatAssistantAttachmentContext);
  if (!context) {
    throw new Error("useChatAssistantAttachments must be used within a ChatAssistantAttachmentContextProvider");
  }
  return context;
}
